/* global jQuery */
window.megamenu = {
  init: function () {

    'use strict'

    jQuery('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon')
    // Checks if li has sub (ul) and adds class for toggle icon - just an UI

    jQuery('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub')
    // Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)

    // jQuery('.menu > ul').before('<a href="#" class="menu-mobile menuceluar">&nbsp; CONTENIDO</a>')

    // Adds menu-mobile class (for mobile toggle menu) before the normal menu
    // Mobile menu is hidden if width is more then 959px, but normal menu is displayed
    // Normal menu is hidden if width is below 959px, and jquery adds mobile menu
    // Done this way so it can be used with wordpress without any trouble

    jQuery('.menu > ul > li').hover(
      function (e) {
        if (jQuery(window).width() > 943) {
          jQuery(this).children('ul').fadeIn(150)
          e.preventDefault()
        }
      }, function (e) {
        if (jQuery(window).width() > 943) {
          jQuery(this).children('ul').fadeOut(150)
          e.preventDefault()
        }
      }
    )
    // If width is more than 943px dropdowns are displayed on hover

    // the following hides the menu when a click is registered outside
    jQuery(document).on('click', function (e) {
      if (jQuery(e.target).parents('.menu').length === 0)
        jQuery('.menu > ul').removeClass('show-on-mobile')
    })

    jQuery('.menu > ul > li').click(function () {
      // no more overlapping menus
      // hides other children menus when a list item with children menus is clicked
      var thisMenu = jQuery(this).children('ul')
      if (thisMenu.length === 0) {
        if (jQuery(window).width() < 943) {
          jQuery('.menu > ul').removeClass('show-on-mobile')
        }
      } else {
        var prevState = thisMenu.css('display')
        jQuery('.menu > ul > li > ul').slideUp()
        if (jQuery(window).width() < 943) {
          if (prevState !== 'block') {
            thisMenu.slideDown(150)
          }
        }
      }
    })
    // If width is less or equal to 943px dropdowns are displayed on click (thanks Aman Jain from stackoverflow)

    jQuery('.menu > ul > li > ul > li').click(function () {
      if (jQuery(window).width() < 943) {
        jQuery('.menu > ul').removeClass('show-on-mobile')
      }
    })

    jQuery('.menu-mobile').click(function (e) {
      jQuery('.menu > ul').toggleClass('show-on-mobile')
      e.preventDefault()
    })
    // when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story (thanks mwl from stackoverflow)
  }
}



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/assets/megamenu/js/megamenu.js